import React from "react";
import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const SettingsItem = ({ onClick, active }) => {
  return (
    <ListItemTab
      icon={Cog6ToothIcon}
      label="Settings"
      onClick={onClick}
      active={active}
    />
  );
};

export default SettingsItem;

